import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { Reports } from "./Reports";
import VolumeReportsWizard from "./volume-reports/VolumeReportsWizard";
import { JSX } from "react";

const ReportsRouter = (props: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route path={`${props.match.path}`} exact={true} component={Reports} />
      <Route
        path={`${props.match.path}/create-volume-report/:reportType`}
        render={(props: RouteComponentProps) => (
          <VolumeReportsWizard {...props} />
        )}
      />
      <Redirect from={`${props.match.path}/create-volume-report`} exact={true} to={`${props.match.path}/`} />
    </Switch >
  );
};

export default ReportsRouter;
